var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"whitespace-nowrap text-white rounded text-center bg-pink-400",class:_vm.getPaddingClasses},[_c('fa-icon',{attrs:{"fixed-width":"","icon":"box"}}),_vm._v(" x "+_vm._s(_vm.quantity)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }